var site = site || {};

site.cliniqueSppSliderV1 = site.cliniqueSppSliderV1 || {};
site.gotL2Cache = false;

(function ($) {
  cliniqueSppSliderV1 = {
    formatter: $('.clinique-spp-slider-v1'),
    formatterParent: $('.cl-spp-slider-formatter-v1')
  };

  Drupal.behaviors.cliniqueSppSliderV1 = {
    get: function (key) {
      return cliniqueSppSliderV1[key];
    },
    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.once('clinique-spp-slider-v1-processed').each(function () {
        var thisFormatter = $(this);
        var thisFormatterParent = thisFormatter.parents(self.get('formatterParent').selector);

        $('.slider-large', thisFormatter).hide();
        var slider_img = thisFormatterParent.find('.outer-wrap').attr('data-sliderimg');

        $('.slider-thumb', thisFormatter).find('a').on('click', function () {
          $('.slider-thumb', thisFormatterParent).find('.step-image').css('border', '1px solid transparent');
          $(this).find('.step-image', thisFormatterParent).css('border', '1px solid #000');
          $('.slider-large', thisFormatterParent).hide();
          thisFormatter.find('.slider-large').show();
          $('.handle img', thisFormatter).attr('src', slider_img);
        });
        // DoneDone #310 - Pop Artistry/Zara Landing Page
        // The brand wants to have a 960px wide slider. 
        // In the future we can add some CMS fields and 
        // make this more flexible, meaning making the 
        // slider have any desired width.
        if (thisFormatter.hasClass('full-width')) {
          $('.second', thisFormatter).slider({
            marginY: 20,
            marginX: 20,
            setX: 480,
            setY: 140,
            direction: 'horizontal'
          });
        } else {
          $('.second', thisFormatter).slider({
            marginY: 20,
            marginX: 20,
            setX: 305,
            setY: 140,
            direction: 'horizontal'
          });
        }
      });
      self.get('formatterParent').each(function () {
        var thisFormatterParent = $(this);

        $('.slider-thumb:first a', thisFormatterParent).trigger('click');
      });
    }
  };
})(jQuery);
